import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { CheckCircle, DeniCircle } from '../../../../assets/icon';
import Button from '../../../../components/Button/Button';
import DropDown from '../../../../components/DropDown/DropDown';
import Loading from '../../../../components/Loading';
import Modal from '../../../../components/Modal/Modal';
import ModalPassword from '../../../../components/ModalPassword/ModalPassword';
import SelectOptions from '../../../../components/SelectOptions';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import { detailAccountsFetchActionReset } from '../../../../store/fetchActions/accountActions';
import { approveUserFetchAction } from '../../../../store/fetchActions/approveUserActions';
import { faceMatchStatusReset } from '../../../../store/fetchActions/faceMatchServicesActions';
import { ocrStatusReset } from '../../../../store/fetchActions/ocrServicesActions';
import { optionsClientsPending } from '../../../../utils/constant';
import { translateMessage } from '../../../../utils/functions/translateMessage';
import AboutCollum from '../Collums/AboutCollum';
import DocumentRow from '../Collums/DocumentRow';
import * as S from './ClientesPendentesPf.styles';
import FaceMatch from './components/faceMatchOcr/FaceMatch';
import Ocr from './components/faceMatchOcr/Ocr';
import ModalSendDocuments from './SendDocumentsClients';

const ClientesPendentesPf = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [hoverColorDeni, setHoverColorDeni] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [nameSelectedItem, setNameSelectedItem] = useState('');
  const [functionSelectedItem, setFunctionSelectedItem] = useState(() => {});
  const [documentTypeToSend, setDocumentTypeToSend] = useState('');
  const [isModalSendDocumentsOpen, setIsModalSendDocumentsOpen] = useState(false);

  const { handleSubmit: handleSubmitApproval, control: controlAproval } = useForm({});

  const { loadingApproveUser } = useSelector((state) => state.approveUser);
  const { usersData, loadingUser, errorUser, errorMessageUser } = useSelector((state) => state.user);
  const { detailAccountsData } = useSelector((state) => state.account);
  const { cobansData } = useSelector((state) => state.cobans);

  const submitApprovation = (data) => (data.perfil ? approveUser(data) : approveError());
  const openModalPassword = () => setIsModalPasswordOpen(true);

  const callFunction = () => {
    const callFunction = {
      editData: () => setIsEditing(true),
      sendImages: () => {
        setDocumentTypeToSend('image/*');
        setIsModalSendDocumentsOpen(true);
      },
      sendDocuments: () => {
        setDocumentTypeToSend('.pdf');
        setIsModalSendDocumentsOpen(true);
      },
    };

    setFunctionSelectedItem(callFunction[nameSelectedItem]);
  };

  const perfisArray = cobansData.filter((val) => val.CPFCNPJ === null);

  const approveError = () => {
    dispatch(
      showAlert({
        title: 'Perfil não selecionado!',
        text: 'Selecione um perfil para aprovar o cliente',
        icon: 'error',
      }),
    );
  };

  const approveUser = (data) => {
    const param = { CPFUSUARIO: props?.userID, ID_COBAN: data.perfil, ID_PRODUTO_DIGITAL: props?.info?.ID_PRODUTO_DIGITAL };
    dispatch(approveUserFetchAction(param, props.close));
  };

  return (
    <Modal
      open={props.open}
      close={() => {
        props.close();
        dispatch(detailAccountsFetchActionReset());
        dispatch(ocrStatusReset());
        dispatch(faceMatchStatusReset());
      }}
      title="Dados Cliente"
      width={'96.222vw'}
    >
      {loadingUser || loadingApproveUser ? (
        <Loading />
      ) : errorUser ? (
        <h1>{translateMessage(errorMessageUser)}</h1>
      ) : (
        <>
          <S.DataValidation>
            <FaceMatch />
            <Ocr />
          </S.DataValidation>

          <S.CardInfo>
            {/* <Information title="Informações Pessoais" data={usersData} /> */}
            <S.EditButtonContainer>
              <h4>Informações Pessoais</h4>
              <DropDown
                isEditing={isEditing}
                openModalPassword={() => setIsModalPasswordOpen(true)}
                options={optionsClientsPending}
                setNameSelectedItem={(e) => setNameSelectedItem(e)}
              />
            </S.EditButtonContainer>
            {loadingUser ? <Loading /> : <AboutCollum isEditing={isEditing} cancel={() => setIsEditing(false)} width='100%' />}
            <DocumentRow document={detailAccountsData?.documentos} />
          </S.CardInfo>

          <S.Form onSubmit={handleSubmitApproval(submitApprovation)}>
            <S.ContainerOptions>
              <S.SectionTitle>Perfil Associado ao cliente</S.SectionTitle>
              <SelectOptions
                control={controlAproval}
                options={perfisArray}
                name={'perfil'}
                width="35.111vw"
                label={'Perfil'}
                required={true}
              />
            </S.ContainerOptions>

            <S.ContainerButtons>
              <S.SectionTitle>Aprovação do Cliente</S.SectionTitle>
              <Button
                backgroundcolor={theme.colors.buttonApproved}
                width="35.111vw"
                height="3.125vw"
                hoverbgcolor={theme.colors.buttonApprovedHover}
                hovercolor={theme.colors.buttonApprovedHoverText}
                mycolor={theme.colors.buttonApprovedText}
                type="submit"
                margin={'0 0 1.083vw 0'}
              >
                <CheckCircle />
                <span>Aprovar</span>
              </Button>
              <Button
                backgroundcolor={theme.colors.buttonNegaded}
                width="35.111vw"
                height="3.125vw"
                hoverbgcolor={theme.colors.buttonNegadedHover}
                hovercolor={theme.colors.buttonNegadedHoverText}
                mycolor={theme.colors.buttonNegadedText}
                onClick={props.deny}
                onMouseOver={() => setHoverColorDeni(theme.colors.white)}
                onMouseOut={() => setHoverColorDeni(theme.colors.white)}
              >
                <DeniCircle color={hoverColorDeni} />
                <span>Negar</span>
              </Button>
            </S.ContainerButtons>
          </S.Form>
        </>
      )}
      {isModalPasswordOpen && (
        <ModalPassword
          openModal={isModalPasswordOpen}
          closeModal={() => setIsModalPasswordOpen(false)}
          nextFunction={callFunction}
        />
      )}
      {isModalSendDocumentsOpen && (
        <ModalSendDocuments
          openModal={isModalSendDocumentsOpen}
          closeModal={() => setIsModalSendDocumentsOpen(false)}
          accept={documentTypeToSend}
        />
      )}
    </Modal>
  );
};

export default ClientesPendentesPf;
